// Crosstalk Mobile — bundle showcase controller
// - Live pricing on antenna selection
// - One-call cart bundling on Add-to-Cart
// - "More info" modal with image gallery + spec content per option
(function () {
  'use strict';

  const root = document.querySelector('[data-cm-bundles-config]')?.closest('section');
  if (!root) return;

  let config = {};
  try {
    config = JSON.parse(document.querySelector('[data-cm-bundles-config]').textContent.trim());
  } catch (e) {
    console.error('[cm-bundles] could not parse config', e);
    return;
  }

  const RATE = config.discount_rate ?? 0.10;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function getSelectedAntenna(bundleId) {
    const el = root.querySelector(
      `[data-cm-bundle-option][data-bundle="${bundleId}"]:checked`
    );
    if (!el) return null;
    return {
      variantId: parseInt(el.dataset.variantId, 10),
      price: parseInt(el.dataset.price, 10),
      handle: el.dataset.handle,
    };
  }

  function isAddonChecked(bundleId) {
    const el = root.querySelector(`[data-cm-bundle-addon="${bundleId}"]`);
    return !!(el && el.checked);
  }

  function getSelectedPlan(bundleId) {
    const el = root.querySelector(
      `[data-cm-bundle-plan][data-bundle="${bundleId}"]:checked`
    );
    if (!el) return null;
    return {
      variantId: parseInt(el.dataset.variantId, 10),
      price: parseInt(el.dataset.price, 10),
      handle: el.dataset.handle,
      billingLabel: el.dataset.billingLabel || 'Plan',
    };
  }

  function recompute(bundleId) {
    const card = root.querySelector(`[data-cm-bundle="${bundleId}"]`);
    if (!card) return;
    const bundle = config.bundles[bundleId];
    if (!bundle) return;

    const antenna = getSelectedAntenna(bundleId);
    const plan = getSelectedPlan(bundleId);
    const routerPrice = bundle.router.price;
    const antennaPrice = antenna?.price ?? 0;
    const addonPrice = (bundle.addon && isAddonChecked(bundleId)) ? bundle.addon.price : 0;
    const planPrice = plan?.price ?? 0;
    const hardwareTotal = routerPrice + antennaPrice + addonPrice;
    const savings = Math.round(hardwareTotal * RATE);
    const grandTotal = hardwareTotal - savings + planPrice;

    const set = (sel, val) => { const el = card.querySelector(sel); if (el) el.textContent = val; };
    set('[data-cm-bundle-hw]', formatMoney(hardwareTotal));
    set('[data-cm-bundle-plan-price]', formatMoney(planPrice));
    set('[data-cm-bundle-plan-label]', plan?.billingLabel || 'Plan');
    set('[data-cm-bundle-savings]', '−' + formatMoney(savings));
    set('[data-cm-bundle-total]', formatMoney(grandTotal));
  }

  Object.keys(config.bundles).forEach((id) => recompute(id));

  function swapBundleImage(bundleId, url) {
    if (!url) return;
    const img = root.querySelector(`img[data-cm-bundle-image="${bundleId}"]`);
    if (!img || img.src === url) return;
    img.src = url;
    img.removeAttribute('srcset');
  }

  root.addEventListener('change', (e) => {
    if (e.target.matches('[data-cm-bundle-option]')) {
      const bundleId = e.target.dataset.bundle;
      recompute(bundleId);
      swapBundleImage(bundleId, e.target.dataset.bundleImage);
      return;
    }
    if (e.target.matches('[data-cm-bundle-addon]')) {
      recompute(e.target.dataset.cmBundleAddon);
      return;
    }
    if (e.target.matches('[data-cm-bundle-plan]')) {
      recompute(e.target.dataset.bundle);
    }
  });

  // ── Add bundle to cart ──────────────────────────
  root.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cm-bundle-add]');
    if (!btn) return;
    e.preventDefault();
    const bundleId = btn.dataset.cmBundleAdd;
    const bundle = config.bundles[bundleId];
    if (!bundle) return;

    const antenna = getSelectedAntenna(bundleId);
    if (!antenna) { alert('Please choose an antenna first.'); return; }

    const plan = getSelectedPlan(bundleId);
    if (!plan) { alert('Please choose a plan first.'); return; }

    const items = [
      { id: bundle.router.variant_id, quantity: 1, properties: { _bundle: bundle.name } },
      { id: antenna.variantId,        quantity: 1, properties: { _bundle: bundle.name } },
      { id: plan.variantId,           quantity: 1, properties: { _bundle: bundle.name } },
    ];

    if (bundle.addon && isAddonChecked(bundleId)) {
      items.push({ id: bundle.addon.variant_id, quantity: 1, properties: { _bundle: bundle.name } });
    }

    btn.classList.add('btn--loading');
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        console.error('[cm-bundles] add failed', err);
        alert(err.description || 'Could not add this bundle. Please try again.');
        return;
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      setTimeout(() => {
        if (!document.querySelector('.cart-drawer.is-active, .cart-drawer--open')) {
          window.location.href = '/cart';
        }
      }, 600);
    } catch (err) {
      console.error('[cm-bundles] error', err);
      alert('Could not add this bundle. Please try again.');
    } finally {
      btn.classList.remove('btn--loading');
      btn.disabled = false;
    }
  });

  // ── More-info modal with image gallery ─────────
  const modal = root.querySelector('[data-cm-bundles-modal]');
  if (modal) {
    const m = {
      gallery: modal.querySelector('[data-cm-bundles-modal-gallery]'),
      slides: modal.querySelector('[data-cm-bundles-modal-slides]'),
      prev: modal.querySelector('[data-cm-bundles-modal-prev]'),
      next: modal.querySelector('[data-cm-bundles-modal-next]'),
      current: modal.querySelector('[data-cm-bundles-modal-current]'),
      total: modal.querySelector('[data-cm-bundles-modal-total]'),
      dots: modal.querySelector('[data-cm-bundles-modal-dots]'),
      eyebrow: modal.querySelector('[data-cm-bundles-modal-eyebrow]'),
      title: modal.querySelector('[data-cm-bundles-modal-title]'),
      price: modal.querySelector('[data-cm-bundles-modal-price]'),
      description: modal.querySelector('[data-cm-bundles-modal-description]'),
      link: modal.querySelector('[data-cm-bundles-modal-link]'),
    };
    let slideCount = 0;

    function buildSlides(imagesTpl) {
      m.slides.innerHTML = '';
      m.dots.innerHTML = '';
      const imgs = imagesTpl ? Array.from(imagesTpl.content.querySelectorAll('img')) : [];
      slideCount = imgs.length;
      if (slideCount === 0) {
        const li = document.createElement('li');
        li.className = 'cm-modal__slide';
        m.slides.appendChild(li);
      } else {
        imgs.forEach((img, i) => {
          const li = document.createElement('li');
          li.className = 'cm-modal__slide';
          const clone = img.cloneNode(true);
          if (i === 0) clone.loading = 'eager';
          li.appendChild(clone);
          m.slides.appendChild(li);
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'cm-modal__dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', `Go to image ${i + 1}`);
          dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          dot.dataset.index = String(i);
          m.dots.appendChild(dot);
        });
      }
      m.gallery.toggleAttribute('data-single', slideCount <= 1);
      m.total.textContent = String(Math.max(slideCount, 1));
      setActiveIndex(0);
      m.slides.scrollLeft = 0;
    }
    function setActiveIndex(idx) {
      m.current.textContent = String(idx + 1);
      m.dots.querySelectorAll('.cm-modal__dot').forEach((d, i) => {
        d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
      m.prev.disabled = idx === 0;
      m.next.disabled = idx >= slideCount - 1;
    }
    function navigate(direction) {
      const w = m.slides.offsetWidth;
      m.slides.scrollBy({ left: w * direction, behavior: 'smooth' });
    }
    function goTo(idx) {
      const w = m.slides.offsetWidth;
      m.slides.scrollTo({ left: w * idx, behavior: 'smooth' });
    }

    let scrollFrame = 0;
    m.slides.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = requestAnimationFrame(() => {
        const w = m.slides.offsetWidth;
        const idx = Math.round(m.slides.scrollLeft / w);
        setActiveIndex(Math.max(0, Math.min(idx, slideCount - 1)));
        scrollFrame = 0;
      });
    });
    m.prev.addEventListener('click', () => navigate(-1));
    m.next.addEventListener('click', () => navigate(1));
    m.dots.addEventListener('click', (e) => {
      const dot = e.target.closest('.cm-modal__dot');
      if (dot) goTo(parseInt(dot.dataset.index, 10));
    });
    modal.addEventListener('keydown', (e) => {
      if (slideCount <= 1) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); navigate(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); navigate(1); }
    });

    root.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-cm-bundles-info-trigger]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();

      const row = trigger.closest('[data-cm-bundle-info-row], .cm-bundle__option-row');
      const imagesTpl = row?.querySelector('[data-cm-bundles-info-images]');
      const specsTpl = row?.querySelector('[data-cm-bundles-info-content]');

      buildSlides(imagesTpl);
      m.eyebrow.textContent = trigger.dataset.infoEyebrow || '';
      m.eyebrow.toggleAttribute('hidden', !trigger.dataset.infoEyebrow);
      m.title.textContent = trigger.dataset.infoTitle || '';
      m.price.textContent = trigger.dataset.infoPrice || '';
      m.link.href = trigger.dataset.infoLink || '#';
      m.description.innerHTML = specsTpl ? specsTpl.innerHTML : '';

      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
    });

    modal.addEventListener('click', (e) => {
      if (e.target === modal) modal.close();
      if (e.target.closest('[data-cm-bundles-modal-close]')) modal.close();
    });
  }
})();
